// extracted by mini-css-extract-plugin
export default {"OwnersStep__description":"OwnersStepWithApplicationId_OwnersStep__description__KPh21"};